import { useMemo } from 'react';

import { useBookmakerFromCode } from './useBookmakerFromCode';

export const useOffersSignUpBookie = (bookieCode: string) => {
  const bookmaker = useBookmakerFromCode(bookieCode);
  return useMemo(() => bookmaker?.offers.signupOffers || [], [bookmaker]);
};
